import {AnyAction} from "redux";
import {EntityListSettings} from "../../../../qdep/components/entity-list-workspace-block/EntityListSettingsState";

enum ProjectListWorkspaceActionTypes {
    UPDATE_SETTINGS = 'WORKSPACE.PROJECT_LIST.UPDATE_SETTINGS',
    SELECT_ROW      = 'WORKSPACE.PROJECT_LIST.SELECT_ROW',
}

function updateSettings(settings: EntityListSettings): AnyAction {
    return {
        type: ProjectListWorkspaceActionTypes.UPDATE_SETTINGS,
        settings: settings,
    }
}

function listSelectRow(index: number): AnyAction {
    return {
        type: ProjectListWorkspaceActionTypes.SELECT_ROW,
        index: index
    }
}

export {
    ProjectListWorkspaceActionTypes,
    updateSettings, listSelectRow,
}